function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBulletList = function SvgBulletList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17790",
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17791",
    d: "M3.75 9.5A1.25 1.25 0 1 0 5 10.75 1.248 1.248 0 0 0 3.75 9.5zm0-5A1.25 1.25 0 1 0 5 5.75 1.248 1.248 0 0 0 3.75 4.5zm0 10A1.25 1.25 0 1 0 5 15.75a1.254 1.254 0 0 0-1.25-1.25zm2.5 2.083h11.667v-1.666H6.25zm0-5h11.667V9.917H6.25zm0-6.667v1.667h11.667V4.917z",
    transform: "translate(-.417 -.75)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgBulletList;